import {createAction, createReducer, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import * as c from "./actions.constants";
import * as s from "./load.status.constants.js";

import cubaService from "common/api/cuba.reqs.service";
import * as sc from "../modules/search/search.constants";
import {
    SEARCH_ACTUAL_STATE_NAME,
    SEARCH_AUTHOR_NAME,
    SEARCH_FIAS_NAME,
    SEARCH_STATUS_NAME
} from "../modules/search/search.constants";

const initialStateSearch = {term: '', filter: {}, offset: 0, pageSize: sc.PAGE_SIZE, page: 0};

// // First, create the thunk
// export const fetchSearch = createAsyncThunk(c.LOAD_CATEGORIES,
//
// );

// ENV.debug.reducer.search
const isDebug = false;

// Then, handle actions in your reducers:
export const searchSlice = createSlice({
    name: 'search',
    initialState: initialStateSearch,
    reducers: {
        dropAll: (state, action) => {
            isDebug && console.log("searchSlice.dropAll");
            state.filter = {};
            console.log('dropAll: drop page');
            state.page = 0;

            // const f = {};
            // // keep category
            // if ( state.filter && state.filter[sc.SEARCH_CATEGORY_NAME] != null ) {
            //     f[sc.SEARCH_CATEGORY_NAME] = state.filter[sc.SEARCH_CATEGORY_NAME];
            // }
            // state.filter = f;

        },
        forceUpdate: (state, action) => {
            isDebug && console.log("searchSlice.forceUpdate");
            state = {...state}
        },
        setTerm: (state, action) => {
            isDebug && console.log("searchSlice.setTerm");
            state.filter = {[sc.SEARCH_TERM_NAME]: action.payload};
            console.log('setTerm: drop page');
            state.page = 0;
        },
        addDictVal: (state, action) => {
            isDebug && console.log("searchSlice.addDictVal");
            state.filter = {...action.payload, ...state.filter};
            console.log('addDictVal: drop page');
            state.page = 0;
        },
        setCategory: (state, action) => {
            isDebug && console.log("searchSlice.setCategory");
            const f = {...state.filter};
            f[sc.SEARCH_CATEGORY_NAME] = action.payload;
            state.filter = f;
            console.log('setCategory: drop page');
            state.page = 0;
        },
        setSingleCategory: (state, action) => {
            isDebug && console.log("searchSlice.setSingleCategory");
            // const f = {...state.filter};
            // f[sc.SEARCH_CATEGORY_NAME] = action.payload;
            state.filter = {[sc.SEARCH_CATEGORY_NAME]: action.payload};
            // console.log('setSingleCategory: drop page');
            // state.page = 0;
        },
        setRegion: (state, action) => {
            isDebug && console.log("searchSlice.setRegion");
            const f = {...state.filter};
            f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = f;
            // console.log('setRegion: drop page');
            // state.page = 0;
        },
        setSingleRegion: (state, action) => {
            isDebug && console.log("searchSlice.setSingleRegion");
            // const f = {...state.filter};
            // f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = {[sc.SEARCH_REGION_NAME]: action.payload};
            // console.log('setSingleRegion: drop page');
            // state.page = 0;
        },
        setSingleDistrict: (state, action) => {
            isDebug && console.log("searchSlice.setSingleDistrict");
            // const f = {...state.filter};
            // f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = {[sc.SEARCH_DISTRICT_NAME]: action.payload};
            // console.log('setSingleDistrict: drop page');
            // state.page = 0;
        },
        setFullFilter: (state, action) => {
            isDebug && console.log("searchSlice.setFullFilter");
            const f = {...action.payload};
            // keep category
            if (state.filter && state.filter[sc.SEARCH_CATEGORY_NAME] != null) {
                f[sc.SEARCH_CATEGORY_NAME] = state.filter[sc.SEARCH_CATEGORY_NAME];
            }
            state.filter = f;
            console.log('setFullFilter: drop page');
            state.page = 0;
        },
        setRawFilter: (state, action) => {
            isDebug && console.log("searchSlice.setRawFilter");
            state.filter = {...action.payload};
            console.log('setRawFilter: drop page');
            state.page = 0;
        },
        setPage: (state, action) => {
            isDebug && console.log("searchSlice.setPage");
            state.page = action.payload;
        },
        setSingleFias: (state, action) => {
            isDebug && console.log("searchSlice.setSingleFias");
            // const f = {...state.filter};
            // f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = {[sc.SEARCH_FIAS_NAME]: action.payload};
            console.log('setSingleFias: drop page');
            state.page = 0;
        },
        setSingleStatus: (state, action) => {
            isDebug && console.log("searchSlice.setSingleStatus");
            // const f = {...state.filter};
            // f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = {[sc.SEARCH_STATUS_NAME]: action.payload};
            console.log('setSingleStatus: drop page');
            state.page = 0;
        },
        setSingleActualState: (state, action) => {
            isDebug && console.log("searchSlice.setSingleActualState");
            // const f = {...state.filter};
            // f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = {[sc.SEARCH_ACTUAL_STATE_NAME]: action.payload};
            console.log('setSingleActualState: drop page');
            state.page = 0;
        },
        setSingleAuthor: (state, action) => {
            isDebug && console.log("searchSlice.setSingleAuthor");
            // const f = {...state.filter};
            // f[sc.SEARCH_REGION_NAME] = action.payload;
            state.filter = {[sc.SEARCH_AUTHOR_NAME]: action.payload};
            console.log('setSingleAuthor: drop page');
            state.page = 0;
        },
        // standard reducer logic, with auto-generated action types per reducer
    },
    /*
    extraReducers: (builder) => {
      builder
      .addCase(fetchCategories.fulfilled, (state, action) => {
        // Add categories to the state array
        state.categories.setTree(action.payload);
        state.status = state.status === s.EMPTY ? s.SUCCESS : state.status;
      })
      // and provide a default case if no other handlers matched
        .addDefaultCase((state, action) => {})
    }
    */
    // extraReducers: {
    //     // Add reducers for additional action types here, and handle loading state as needed
    //     [fetchSearch.fulfilled]: (state, action) => {
    //         // Add user to the state array
    //         //state.categories.setTree(action.payload);
    //         state.data = action.payload;
    //         state.status = s.SUCCESS;
    //     }
    // }
});

export const searchSliceActions = searchSlice.actions;
export const searchSliceReducer = searchSlice.reducer;
